const { reactive } = require('vue');

const MODEL = {
	name: null,
	investmentPeriod: null,
	groupName: null,
	riskId: null,
	currency: null
};
const model = reactive({ ...MODEL });
const clearModel = () => Object.assign(model, MODEL);

export const useForm = () => {
	return {
		model,
		clearModel
	};
};
